const  router = [
	{
		path: "/base/layout",
		component: () => import('../../../pages/base/Layout.vue'),
		meta: {title: '基本配置'},
		name: 'baseIndex',
		children:[
			{
				path: "/template",
				component: () => import('../../../pages/base/Template.vue'),
				meta: {title: '模板配置', type:'c', permission: 'template_index'},
				name: 'baseIndex', // 选中的效果
			},
			{
				path: "/template/edit",
				component: () => import('../../../pages/base/EditTemplate.vue'),
				meta: {title: '编辑模板', type:'c', permission: 'template_index_edit'},
				name: 'template_index_edit'
			},
			// {
			// 	path: "/base_level",
			// 	component: () => import('../../../pages/base/Level.vue'),
			// 	meta: {title: '等级配置', type:'c', permission: 'level_index'},
			// 	name: 'level_index',
			// },
			
		],
	}
];

export default router